import {Component, Renderer2} from '@angular/core';
import packageConfig from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent {
  public appVersion: string = packageConfig.version;

  constructor(private renderer: Renderer2) {
  }

  public toggleContainer() {
    if (document.body.className.indexOf('fluid') > -1 ) {
      this.renderer.removeClass(document.body, 'fluid');
    }
    else {
      this.renderer.addClass(document.body, 'fluid');
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.component.ts